import * as React from "react"
import { Popover as PopoverPrimitive } from "@base-ui/react/popover"

import { cn } from "@/core/utils"

// Base Popover
const Popover = PopoverPrimitive.Root

// PopoverTrigger
const PopoverTrigger = React.forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Trigger>
>(({ ...props }, ref) => (
  <PopoverPrimitive.Trigger ref={ref} {...props} />
))
PopoverTrigger.displayName = "PopoverTrigger"

// PopoverAnchor - Base UI typically handles anchoring via Trigger or dedicated API. 
// For now, removing direct equivalent exporting or keeping as simple wrapper if needed.
// Leaving as a pass-through div if previously used for checking, but simpler to remove if unused.
// Re-implementing as simple pass-through or removing to avoid type errors.
// Since Base UI doesn't have an Anchor component in the same way (it uses Positioner anchor prop), 
// we will comment it out or remove it to avoid confusion.
// const PopoverAnchor... (Remedying by removing it)

// Default content styles - z-9999 ensures popover appears above dialogs
const CONTENT_BASE_CLASSES =
  "max-w-screen bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-9999 min-w-72 rounded-md border p-4 shadow-md outline-none"

// PopoverContent
const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Popup>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Popup> &
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Positioner>
>(({ className, align = "center", sideOffset = 4, side, ...props }, ref) => (
  <PopoverPrimitive.Portal >
    <PopoverPrimitive.Positioner align={align} sideOffset={sideOffset} side={side} className={'z-80'}>
      <PopoverPrimitive.Popup
        ref={ref}
        className={cn(CONTENT_BASE_CLASSES, className)}
        {...props}
      />
    </PopoverPrimitive.Positioner>
  </PopoverPrimitive.Portal>
))
PopoverContent.displayName = "PopoverContent"

export { Popover, PopoverTrigger, PopoverContent }
